var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFallingRocks(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 216 216",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:none;stroke:currentColor;stroke-linecap:round;stroke-linejoin:round;stroke-width:6px;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M55.85,179.8l-1.26-16.9L42.77,151.28s-10.92,9.85-14.25,13.18,3.64,17.93,3.64,17.93H181.49V57.44L161.64,43,109.51,97.35l10.74,36.89-11.07,48.22"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "94.24 117.8 95.03 135.78 79.47 146.88 63.05 127.84 70.37 115.53 94.24 117.8"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "76.6 74.53 96.02 88.6 112.75 64.53 84.08 54.49 76.6 74.53"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFallingRocks);
export default __webpack_public_path__ + "static/media/FALLING_ROCKS.80a68519056cf6da9597265126edfa67.svg";
export { ForwardRef as ReactComponent };